<template>
    <div>
        <div class="ftc-c">
            <div class="ftc-c-meta">
                <div class="inline-block">
                    <span class="heading">{{ name }}</span>
                    <span style="font-size: larger; color: rgba(187,0,0,0.85); font-family: 'Old Stamper'">{{ this.campaignStatus[campaign_status] }}</span>
                </div>
                <div>
                  <span>Time: {{ time }}</span><br>
                  <span>Platform: {{ this.simPlatform[platform] }}</span>
                </div>
                <div>
                    <!--<span>Number of participating units: {{ units }}</span>-->
                    <span>Missions completed: {{ missions }}</span>
                    <span>Sorties flown: {{ sorties }}</span>
                </div>
                <div>
                    <span>Average participants per mission: {{ avg_attendance }}</span>
                </div>
            </div>

            <div class="ftc-c-thumbnail">
                <!--<span v-if="is_primary">Primary campaign</span>-->
                <!--<span v-else>Side campaign</span>-->
                <span><img class="campaignImage" :src="image"/></span>
            </div>
        </div>
        <div class="button-margin" v-if="description !== null">
            <HideableDiv v-bind:changing-button="true">
            <template slot="buttonVisible">
                <button>Hide description</button>
            </template>
            <template slot="buttonHidden">
                <button>Show description</button>
                </template>
                <div class="button-margin" >{{description}}</div>
            </HideableDiv>
        </div>
    </div>
</template>

<script>
  import statConv from '../../resource/statusConverter'
  import HideableDiv from '../basic_comp/HideableDiv'

  export default {
    name: "CampaignInfoBaseComp",
    components: {HideableDiv},
    mixins: [statConv],
    props: {
      name: String,
      is_primary: Number,
      campaign_status: Number,
      platform: Number,
      time: [String, Number],
      units: Number,
      missions: Number,
      sorties: Number,
      avg_attendance: Number,
      image: {
        type: String,
        default: null
      },
      description: {
        type: String,
        default: null
      }
    },
  }
</script>

<style scoped>

.ftc-c {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    }

.ftc-meta {
    width: 70%;
    }

.ftc-c-thumbnail {
    margin-left: auto;
    }

.button-margin{
    margin: 5px 0px 5px 0px;
    }

.campaignImage{
    height: 126px;
    width: 200px;
    border-radius: 15px;
    float: none;
    box-shadow: 5px 5px 5px rgba(5,5,5,0.3);
    }

</style>



// WEBPACK FOOTER //
// src/components/campaign/CampaignInfoBaseComp.vue